import Index from "@/components/Index";
// Login
import Login from "@/components/Login";
import ResetPassword from "@/components/ResetPassword";
import Pishkhan from "@/components/Pishkhan";
// Panel Layout
import PanelLayout from "@/components/Panel";

// Orders
import Calendar from "@/components/Admin/Calendar";
import OrdersIndex from "@/components/Admin/Orders/Index";
import OrdersCreate from "@/components/Admin/Orders/Create";
import OrdersSingle from "@/components/Admin/Orders/Single";
import AddMedias from "@/components/Admin/Orders/AddMedias";
import Medias from "@/components/Admin/Orders/Medias";
import AdminOrganizationOrder from "@/components/Admin/Orders/Organization/Create";

import AdminCashBack from "@/components/Admin/CashBack/Index";
import AdminCashBackShow from "@/components/Admin/CashBack/Single";

// Admin -> Organizations
import Organizations from "@/components/Admin/Organization/Index";
import CreateOrganization from "@/components/Admin/Organization/Create";
import OrganizationsCreateOrUpdate from "@/components/Admin/Organization/CreateOrUpdate";

// Admin -> Users
import Users from "@/components/Admin/Users/Index";
import CreateUser from "@/components/Admin/Users/Create";
import UsersUpdate from "@/components/Admin/Users/Update";

// Pishkhan
import PishkhanOrdersCreate from "@/components/Pishkhan/Orders/Create";

// Organization
import OrganizationOrders from "@/components/Organization/Orders/Index";
import OrganizationOrder from "@/components/Organization/Orders/Single";
import OrganizationCalendar from "@/components/Organization/Calendar";
import OrganizationPans from "@/components/Organization/Pans";
import OrganizationOrdersCreate from "@/components/Organization/Orders/Create";
import OrganizationOrdersAddData from "@/components/Organization/Orders/AddData";
import OrganizationOrdersDataList from "@/components/Organization/Orders/Data";
import OrganizationPersonnel from "@/components/Organization/Personnels";
import organizationForeignersCreateOrUpdate from "@/components/Organization/Foreigners/CreateOrUpdate";
import organizationForeignersInquiryFidaCode from "@/components/Organization/Foreigners/InquiryFidaCode";
import organizationForeignersRequests from "@/components/Organization/Foreigners/Index";
import organizationForeignersDetail from "@/components/Organization/Foreigners/View";
import organizationForeignersInquiry from "@/components/Organization/Foreigners/Inquiry";

//Consumers
import organizationForeignersConsumners from "@/components/Organization/Consumers/Index";
import organizationForeignersConsumnersDetail from "@/components/Organization/Consumers/View";

// Bonus Cards
import BonusCardsIndex from "@/components/BonusCard/Index";
import BonusCardsSingle from "@/components/BonusCard/Single";
import BonusCardsCreate from "@/components/BonusCard/Create";
import BonusCardsContract from "@/components/BonusCard/Contract";
import BonusCardsBalance from "@/components/BonusCard/CardsBalance";
import BonusCardsCharge from "@/components/BonusCard/Charge";
import BonusCardsRequests from "@/components/BonusCard/Requests";
import BonusCardsRequestsShow from "@/components/BonusCard/RequestsShow";
import BonusCardsPassword from "@/components/BonusCard/CardPassword";
import BonusCardsBlockUnblock from "@/components/BonusCard/BlockUnblock";
import BonusCardsOperations from "@/components/BonusCard/Operations";

// Debit Cards
import DebitCardsIndex from "@/components/DebitCard/Index";
import DebitCardsReport from "@/components/DebitCard/Report";
import DebitCardsEmailReport from "@/components/DebitCard/EmailReport";

//Jahesh
import jaheshCharge from "@/components/Jahesh/Charge";
// import jaheshCardsList from "@/components/Jahesh/CardsList";
import jaheshChargeReport from "@/components/Jahesh/ChargeReport";
import jaheshChargeList from "@/components/Jahesh/ChargeList";

// Foreign Bonus Cards
import ForeignBonusCardsIndex from "@/components/CustomOrganization/BonusCard/Index";
import ForeignBonusCardsCreate from "@/components/CustomOrganization/BonusCard/Create";
import ForeignBonusCardsCharge from "@/components/CustomOrganization/BonusCard/Charge";
import ForeignBonusCardsSingle from "@/components/CustomOrganization/BonusCard/Single";
import ForeignBonusCardsRequests from "@/components/CustomOrganization/BonusCard/Requests";
import ForeignBonusCardsRequestsShow from "@/components/CustomOrganization/BonusCard/RequestsShow";
import Tourists from "@/components/CustomOrganization/Tourists";
import CardDeposit from "@/components/CustomOrganization/CardDeposit";

// Bank Branches
import BankBranchesIndex from "@/components/BankBranches/Index";
import BankBranchesCardBodyIndex from "@/components/BankBranches/CardBody/Index";
import BankBranchesCardBodyBranch from "@/components/BankBranches/CardBody/Branch";
import BankBranchesCardBodyBranchSingle from "@/components/BankBranches/CardBody/Single";
import BankBranchesCreate from "@/components/BankBranches/Create";
import BankBranchesCharge from "@/components/BankBranches/Charge";
import BankBranchesSingle from "@/components/BankBranches/Single";
import BankBranchesRequests from "@/components/BankBranches/Requests";
import BankBranchesRequestsShow from "@/components/BankBranches/RequestsShow";
import BankBranchesCustomers from "@/components/BankBranches/Customers";
import BankBranchesPassword from "@/components/BankBranches/CardPassword";
import BankBranchesBlockUnblock from "@/components/BankBranches/BlockUnblock";
import BankBranchesEvents from "@/components/BankBranches/Events/Index";
import BankBranchesTransactions from "@/components/BankBranches/Transactions/Index";
import BankBranchesReissue from "@/components/BankBranches/Reissue";

// Ware House
import WareHouseCardBodyIndex from "@/components/WareHouse/CardBody/Index";
import WareHouseCardBodyStore from "@/components/WareHouse/CardBody/Store";
import WareHouseCardBodyBranchSingle from "@/components/WareHouse/CardBody/Single";

// Wallet
import OrganizationDeposit from "@/components/CustomOrganization/Wallet";
import OrganizationWalletCashBack from "@/components/CustomOrganization/CashBack/Index";
import OrganizationCallback from "@/components/CustomOrganization/Callback";
import Transactions from "@/components/CustomOrganization/Transactions";
import TransactionsShow from "@/components/CustomOrganization/TransactionsShow";

// Change Password
import ChangePassword from "@/components/ChangePassword";

// Reports
import ReportsCustomerReport from "@/components/BankBranches/Reports/CustomerReport";
import ReportsDetailGift from "@/components/BankBranches/Reports/DetailGift";
import ReportsStock from "@/components/BankBranches/Reports/Stock";
import ReportsBill from "@/components/BankBranches/Reports/Bill";
import ReportsTransactions from "@/components/BankBranches/Reports/Transactions";
import ReportsCardBody from "@/components/BankBranches/Reports/CardBody";
import ReportsCharge from "@/components/BankBranches/Reports/Charge";
import ReportsExpress from "@/components/BankBranches/Reports/Express";

// Themes
import ThemeIndex from "@/components/Admin/Themes/Index";
import ThemeCreate from "@/components/Admin/Themes/Create";
import ThemeUpdate from "@/components/Admin/Themes/Update";

import DebitCardsLabel from "@/components/DebitCard/Label";
import BankBranchesLabel from "@/components/BankBranches/Label";

// Mosque
import MosqueIndex from "@/components/Mosque/Index";
import MosqueCreate from "@/components/Mosque/Create";
import MosqueView from "@/components/Mosque/View";
import CardChargeReport from "@/components/Mosque/CardChargeReport";
import AccountWithdrawalReport from "@/components/Mosque/AccountWithdrawalReport";
import TransactionsList from "@/components/Mosque/TransactionsList";
import CardsList from "@/components/Mosque/CardsList";
import CardCharge from "@/components/Mosque/CardCharge";

// Logistic
import LogisticIndex from "@/components/Admin/Logistic/Index";

// Orgenization Charge src\components\Organization\Charge\Index.vue
import CreateOrgenizationCharge from "@/components/Organization/Charge/Create.vue";
import ListOrgenizationCharge from "@/components/Organization/Charge/Index.vue";
import DetailOrgenizationCharge from "@/components/Organization/Charge/Detail.vue";
import ReportOrgenizationCharge from "@/components/Organization/Charge/Report.vue";
import OrganizationDirectDebit from "@/components/Organization/DirectDebit.vue";

import ChangeCardPin from "@/components/Admin/ChangePin";
import ChangeCardPinReport from "@/components/Admin/ChangePinReport";

export default [
  { path: "/login", name: "login", component: Login, meta: { title: "ورود" } },
  {
    path: "/reset-password",
    name: "resetPassword",
    component: ResetPassword,
    meta: { title: "فراموشی رمز عبور" },
  },
  {
    path: "/auth/pishkhan/:token",
    name: "login.pishkhan",
    component: Pishkhan,
    meta: { title: "ورود" },
  },
  {
    path: "/debit-cards/label",
    name: "debitCards.label",
    component: DebitCardsLabel,
    meta: { title: "چاپ لیبل سفارشات" },
  },
  {
    path: "/bank-branches/label",
    name: "bankBranches.label",
    component: BankBranchesLabel,
    meta: { title: "چاپ لیبل" },
  },
  {
    path: "/",
    component: PanelLayout,
    children: [
      {
        path: "/",
        name: "index",
        component: Index,
        meta: { title: "داشبورد" },
      },
      {
        path: "/change-password",
        name: "changePassword",
        component: ChangePassword,
        meta: { title: "تغییر رمز عبور" },
      },
      {
        path: "calendar",
        name: "calendar",
        component: Calendar,
        meta: { title: "تقویم مناسبت ها" },
      },
      {
        path: "organizations",
        name: "organizations",
        component: Organizations,
        meta: { title: "سازمان ها" },
      },
      {
        path: "organizations/update/:id",
        name: "organizations.update",
        component: OrganizationsCreateOrUpdate,
        meta: { title: "به روزرسانی سازمان" },
      },
      {
        path: "organizations/create",
        name: "organization.create",
        component: OrganizationsCreateOrUpdate,
        meta: { title: "ایجاد سازمان" },
      },
      {
        path: "organizations/contracts/:id?",
        name: "organizations.contracts",
        component: BonusCardsContract,
        meta: { title: "سازمان ها" },
      },
      {
        path: "organizations/create/:close?",
        name: "create.organization",
        component: CreateOrganization,
        meta: { title: "ایجاد سازمان" },
      },
      {
        path: "jahesh/charge",
        name: "jahesh.charge",
        component: jaheshCharge,
        meta: { title: "شارژ جهش" },
      },
      // {
      //   path: "jahesh/cardsList",
      //   name: "jahesh.cardsList",
      //   component: jaheshCardsList,
      //   meta: { title: "لیست کارت ها" },
      // },
      {
        path: "jahesh/chargeList",
        name: "jahesh.chargeList",
        component: jaheshChargeList,
        meta: { title: "لیست شارژ" },
      },
      {
        path: "jahesh/chargeReport/:id",
        name: "jahesh.chargeReport",
        component: jaheshChargeReport,
        meta: { title: "گزارش شارژ" },
      },
      {
        path: "users",
        name: "users",
        component: Users,
        meta: { title: "کاربران" },
      },
      {
        path: "users/create",
        name: "users.create",
        component: CreateUser,
        meta: { title: "ایجاد کاربر" },
      },
      {
        path: "users/update/:id",
        name: "users.update",
        component: UsersUpdate,
        meta: { title: "به روزرسانی کاربر" },
      },
      {
        path: "cash-back",
        name: "cashback",
        component: AdminCashBack,
        meta: { title: "درخواست های بازگشت وجه" },
      },
      {
        path: "cash-back/:id",
        name: "cashback.show",
        component: AdminCashBackShow,
        meta: { title: "مشاهده درخواست بازگشت وجه" },
      },
      // Mosque
      {
        path: "mosque/list",
        name: "mosque.index",
        component: MosqueIndex,
        meta: { title: "سازمان مساجد" },
      },
      {
        path: "mosque/account-withdrawal-report",
        name: "account.withdrawal.report",
        component: AccountWithdrawalReport,
        meta: { title: "گزارش برداشت از حساب" },
      },
      {
        path: "mosque/card-charge-report",
        name: "card.charge.report",
        component: CardChargeReport,
        meta: { title: "گزارش شارژ کارت" },
      },
      {
        path: "mosque/card-charge-report/:id",
        name: "card.charge.report.id",
        component: CardChargeReport,
        meta: { title: "گزارش شارژ کارت" },
      },
      {
        path: "transactionsList",
        name: "account.transactions",
        component: TransactionsList,
        meta: { title: "لیست تراکنش ها" },
      },
      {
        path: "/cardsList",
        name: "cards.list",
        component: CardsList,
        meta: { title: "لیست کارت های صادر شده" },
      },
      // { path: 'cardCharge', name: 'account.charge', component: CardCharge, meta: { title: 'گزارش شارژ' } },
      {
        path: "mosque/create",
        name: "mosque.create",
        component: MosqueCreate,
        meta: { title: "اتصال کارت به پایانه" },
      },
      {
        path: "mosque/:id",
        name: "mosque.view",
        component: MosqueView,
        meta: { title: "مشاهده پایانه تخصیص یافته" },
      },
      // Orders
      {
        path: "orders",
        name: "orders.index",
        component: OrdersIndex,
        meta: { title: "سفارش کارت هدیه" },
      },
      {
        path: "orders/create",
        name: "orders.create",
        component: OrdersCreate,
        meta: { title: "ثبت سفارش" },
      },
      {
        path: "orders/:id",
        name: "orders.show",
        component: OrdersSingle,
        meta: { title: "مشاهده جزئیات سفارش" },
      },
      {
        path: "medias",
        name: "orders.medias.index",
        component: Medias,
        meta: { title: "چندرسانه ای" },
      },
      {
        path: "medias/add",
        name: "orders.medias.add",
        component: AddMedias,
        meta: { title: "افزودن چندرسانه ای" },
      },
      {
        path: "organization-order",
        name: "admin.organizationOrder",
        component: AdminOrganizationOrder,
        meta: { title: "ثبت سفارش سازمانی" },
      },
      // Pishkhan
      {
        path: "pishkhan",
        name: "pishkhan.index",
        component: PishkhanOrdersCreate,
        meta: { title: "ثبت سفارش" },
      },
      // Organization
      {
        path: "organization-orders",
        name: "organization.index",
        component: OrganizationOrders,
        meta: { title: "سفارشات" },
      },
      {
        path: "organization-pans",
        name: "organization.uploadData",
        component: OrganizationPans,
        meta: { title: "ثبت اطلاعات پن ها" },
      },
      {
        path: "organization-calendar",
        name: "organization.calendar",
        component: OrganizationCalendar,
        meta: { title: "تقویم مناسبت ها" },
      },
      {
        path: "organization-orders/create",
        name: "organization.create",
        component: OrganizationOrdersCreate,
        meta: { title: "ثبت سفارش" },
      },
      {
        path: "organization-personnels",
        name: "organization.personnels",
        component: OrganizationPersonnel,
        meta: { title: "پرسنل" },
      },
      {
        path: "organization-data",
        name: "organization.dataList",
        component: OrganizationOrdersDataList,
        meta: { title: "لیست متن ها و تصاویر" },
      },
      {
        path: "organization-data/create",
        name: "organization.addData",
        component: OrganizationOrdersAddData,
        meta: { title: "افزودن تصویر و متن دلخواه" },
      },
      {
        path: "organization-orders/:id",
        name: "organization.show",
        component: OrganizationOrder,
        meta: { title: "مشاهده جزئیات سفارش" },
      },
      // Bonus Cards
      {
        path: "bonus-cards",
        name: "bonusCards.index",
        component: BonusCardsIndex,
        meta: { title: "بن کارت" },
      },
      {
        path: "bonus-cards/operations",
        name: "bonusCards.operations",
        component: BonusCardsOperations,
        meta: { title: "" },
      },
      {
        path: "bonus-cards/create",
        name: "bonusCards.create",
        component: BonusCardsCreate,
        meta: { title: "ثبت درخواست" },
      },
      {
        path: "bonus-cards/contract",
        name: "bonusCards.contract",
        component: BonusCardsContract,
        meta: { title: "ایجاد قرارداد" },
      },
      {
        path: "bonus-cards/accountBalance",
        name: "bonusCards.account.balance",
        component: BonusCardsBalance,
        meta: { title: "دریافت موجودی" },
      },
      {
        path: "bonus-cards/charge",
        name: "bonusCards.charge",
        component: BonusCardsCharge,
        meta: { title: "شارژ بن کارت" },
      },
      {
        path: "bonus-cards/requests",
        name: "bonusCards.requests",
        component: BonusCardsRequests,
        meta: { title: "لیست درخواست ها" },
      },
      {
        path: "bonus-cards/requests/:id",
        name: "bonusCards.requests.show",
        component: BonusCardsRequestsShow,
        meta: { title: "جزئیات درخواست" },
      },
      {
        path: "bonus-cards/card-pin",
        name: "bonusCards.cardPin",
        component: BankBranchesPassword,
        meta: { title: "صدور رمز کارت" },
      },
      {
        path: "bonus-cards/card-block-unblock",
        name: "bonusCards.blockUnblock",
        component: BonusCardsBlockUnblock,
        meta: { title: "درخواست مسدودی / رفع مسدودی کارت" },
      },
      {
        path: "bonus-cards/:id",
        name: "bonusCards.single",
        component: BonusCardsSingle,
        meta: { title: "جزئیات سفارش" },
      },
      // Bank Branches
      {
        path: "bank-branches-card-body",
        name: "bankBranches.cardBody.index",
        component: BankBranchesCardBodyIndex,
        meta: { title: "سفارشات" },
      },
      {
        path: "bank-branches-card-body/create",
        name: "bankBranches.cardBody.branch",
        component: BankBranchesCardBodyBranch,
        meta: { title: "ایجاد سفارش جدید" },
      },
      {
        path: "bank-branches-card-body/:id",
        name: "bankBranches.cardBody.branch.single",
        component: BankBranchesCardBodyBranchSingle,
        meta: { title: "جزئیات سفارش" },
      },
      {
        path: "bank-branches",
        name: "bankBranches.index",
        component: BankBranchesIndex,
        meta: { title: "سفارشات" },
      },
      {
        path: "bank-branches/create",
        name: "bankBranches.create",
        component: BankBranchesCreate,
        meta: { title: "ثبت درخواست" },
      },
      {
        path: "bank-branches/charge",
        name: "bankBranches.charge",
        component: BankBranchesCharge,
        meta: { title: "شارژ کارت" },
      },
      {
        path: "bank-branches/requests",
        name: "bankBranches.requests",
        component: BankBranchesRequests,
        meta: { title: "لیست درخواست ها" },
      },
      {
        path: "bank-branches/requests/:id",
        name: "bankBranches.requests.show",
        component: BankBranchesRequestsShow,
        meta: { title: "جزئیات درخواست" },
      },
      {
        path: "bank-branches/card-pin",
        name: "bankBranches.cardPin",
        component: BankBranchesPassword,
        meta: { title: "صدور رمز کارت" },
      },
      {
        path: "card-block-unblock",
        name: "bankBranches.blockUnblock",
        component: BankBranchesBlockUnblock,
        meta: { title: "درخواست مسدودی / رفع مسدودی کارت" },
      },
      {
        path: "bank-branches-customers",
        name: "bankBranches.customers",
        component: BankBranchesCustomers,
        meta: { title: "مشریان" },
      },
      {
        path: "bank-branches-events",
        name: "bankBranches.events",
        component: BankBranchesEvents,
        meta: { title: "رویداد ها" },
      },
      {
        path: "bank-branches-transactions",
        name: "bankBranches.transactions",
        component: BankBranchesTransactions,
        meta: { title: "تراکنش ها" },
      },
      {
        path: "bank-branches/:id",
        name: "bankBranches.single",
        component: BankBranchesSingle,
        meta: { title: "جزئیات سفارش" },
      },
      {
        path: "reissue",
        name: "reissue",
        component: BankBranchesReissue,
        meta: { title: "صدور کارت المثنی" },
      },
      // Ware House
      {
        path: "ware-house-card-body",
        name: "wareHouse.cardBody.index",
        component: WareHouseCardBodyIndex,
        meta: { title: "سفارشات" },
      },
      {
        path: "ware-house-card-body/create",
        name: "wareHouse.cardBody.branch",
        component: WareHouseCardBodyStore,
        meta: { title: "ایجاد سفارش جدید" },
      },
      {
        path: "ware-house-card-body/:id",
        name: "wareHouse.cardBody.branch.single",
        component: WareHouseCardBodyBranchSingle,
        meta: { title: "جزئیات سفارش" },
      },
      // Debit Card
      {
        path: "debit-cards",
        name: "debitCards.index",
        component: DebitCardsIndex,
        meta: { title: "کارت نقدی" },
      },
      {
        path: "debit-cards-reports",
        name: "debitCards.report",
        component: DebitCardsReport,
        meta: { title: "گزارشات هزینه ارسال" },
      },
      {
        path: "debit-cards/email-reports",
        name: "debitCards.emailReports",
        component: DebitCardsEmailReport,
        meta: { title: "گزارشات ایمیل" },
      },
      // Custom Organization
      {
        path: "foreign-bonus-cards",
        name: "foreignBonusCards.index",
        component: ForeignBonusCardsIndex,
        meta: { title: "بن کارت گردشگری" },
      },
      {
        path: "foreign-bonus-cards/create",
        name: "foreignBonusCards.create",
        component: ForeignBonusCardsCreate,
        meta: { title: "ثبت درخواست" },
      },
      {
        path: "foreign-bonus-cards/charge",
        name: "foreignBonusCards.charge",
        component: ForeignBonusCardsCharge,
        meta: { title: "شارژ بن کارت" },
      },
      {
        path: "foreign-bonus-cards/requests",
        name: "foreignBonusCards.requests",
        component: ForeignBonusCardsRequests,
        meta: { title: "لیست درخواست ها" },
      },
      {
        path: "foreign-bonus-cards/requests/:id",
        name: "foreignBonusCards.requests.show",
        component: ForeignBonusCardsRequestsShow,
        meta: { title: "جزئیات درخواست" },
      },
      {
        path: "foreign-bonus-cards/:id",
        name: "foreignBonusCards.single",
        component: ForeignBonusCardsSingle,
        meta: { title: "جزئیات سفارش" },
      },
      {
        path: "bunus-card-deposit",
        name: "bonusCardDeposit",
        component: CardDeposit,
        meta: { title: "دریافت موجودی کارت" },
      },
      {
        path: "tourists",
        name: "foreignBonusCards.tourists",
        component: Tourists,
        meta: { title: "لیست گردشگران" },
      },
      {
        path: "wallet",
        name: "organization.wallet",
        component: OrganizationDeposit,
        meta: { title: "کیف پول" },
      },
      {
        path: "wallet/cash-back",
        name: "organization.wallet.cashBack",
        component: OrganizationWalletCashBack,
        meta: { title: "لیست درخواست های بازگشت وجه" },
      },
      {
        path: "callback/:token",
        name: "organization.callback",
        component: OrganizationCallback,
        meta: { title: "کیف پول" },
      },
      {
        path: "transactions",
        name: "organization.transactions",
        component: Transactions,
        meta: { title: "تراکنش های کیف پول" },
      },
      {
        path: "transactions/:id",
        name: "organization.transactions.show",
        component: TransactionsShow,
        meta: { title: "مشاهده تراکنش" },
      },
      {
        path: "organization-foreigners/create",
        name: "organizationForeigners.create",
        component: organizationForeignersCreateOrUpdate,
        meta: { title: "ثبت درخواست" },
      },
      {
        path: "organization-foreigners/inquiryFidaCode",
        name: "organizationForeigners.inquiryFidaCode",
        component: organizationForeignersInquiryFidaCode,
        meta: { title: "استعلام کد فیدا" },
      },
      {
        path: "organization-foreigners/detail/:id",
        name: "organizationForeigners.view",
        component: organizationForeignersDetail,
        meta: { title: "مشاهده درخواست ها" },
      },
      {
        path: "organization-foreigners/requests",
        name: "organizationForeigners.requests",
        component: organizationForeignersRequests,
        meta: { title: "لیست درخواست ها" },
      },
      {
        path: "organization-foreigners/update/:id",
        name: "organizationForeigners.update",
        component: organizationForeignersCreateOrUpdate,
        meta: { title: "به روزرسانی مشخصات اتباع" },
      },
      {
        path: "organization-foreigners/inquiry",
        name: "organizationForeigners.inquiry",
        component: organizationForeignersInquiry,
        meta: { title: "   استعلام کد فیدا " },
      },
      // Consumers
      {
        path: "organization-foreigners/consumers",
        name: "organizationForeigners.consumers.list",
        component: organizationForeignersConsumners,
        meta: { title: " لیست شرکت های همکار " },
      },
      {
        path: "organization-foreigners/consumer-detail/:id",
        name: "organizationForeigners.consumer.view",
        component: organizationForeignersConsumnersDetail,
        meta: { title: " به روزرسانی شرکت همکار " },
      },
      {
        path: "organization-foreigners/consumer-detail",
        name: "organizationForeigners.consumer.create",
        component: organizationForeignersConsumnersDetail,
        meta: { title: "ایجاد شرکت همکار " },
      },
      // reports
      {
        path: "reports/customer-report",
        name: "bankBranches.reports.customerReport",
        component: ReportsCustomerReport,
        meta: { title: "گزارشات مشتریان" },
      },
      {
        path: "reports/detail-gift",
        name: "bankBranches.reports.detailGift",
        component: ReportsDetailGift,
        meta: { title: "سفارشات کارت شخصی سازی شده" },
      },
      {
        path: "reports/stock",
        name: "bankBranches.reports.stock",
        component: ReportsStock,
        meta: { title: "گزارشات انبار" },
      },
      {
        path: "reports/bill",
        name: "bankBranches.reports.bill",
        component: ReportsBill,
        meta: { title: "گزارشات صورتحساب" },
      },
      {
        path: "reports/transactions",
        name: "bankBranches.reports.transactions",
        component: ReportsTransactions,
        meta: { title: "گزارشات تراکنش ها" },
      },
      {
        path: "reports/card-body",
        name: "bankBranches.reports.cardBody",
        component: ReportsCardBody,
        meta: { title: "گزارشات جسم کارت" },
      },
      {
        path: "reports/charge",
        name: "bankBranches.reports.charge",
        component: ReportsCharge,
        meta: { title: "گزارشات شارژ کارت" },
      },
      {
        path: "reports/express",
        name: "bankBranches.reports.express",
        component: ReportsExpress,
        meta: { title: "مرسولات پستی" },
      },
      // themes
      {
        path: "themes",
        name: "themes.index",
        component: ThemeIndex,
        meta: { title: "طرح ها" },
      },
      {
        path: "themes/create",
        name: "themes.create",
        component: ThemeCreate,
        meta: { title: "افزودن طرح جدید" },
      },
      {
        path: "themes/update/:id",
        name: "themes.update",
        component: ThemeUpdate,
        meta: { title: "به روزرسانی طرح" },
      },
      // logistic
      {
        path: "logistic",
        name: "logistic",
        component: LogisticIndex,
        meta: { title: "مدیریت اسناد" },
      },
      // orgenization charge
      {
        path: "organizationCharge/create",
        name: "organizationCharge.create",
        component: CreateOrgenizationCharge,
        meta: { title: "ایجاد شارژ کارت" },
      },
      {
        path: "organizationCharge/list",
        name: "organizationCharge.list",
        component: ListOrgenizationCharge,
        meta: { title: "لیست درخواست های شارژ کارت " },
      },
      {
        path: "organizationCharge/detail/:id",
        name: "organizationCharge.detail",
        component: DetailOrgenizationCharge,
        meta: { title: "مشاهده درخواست شارژ کارت" },
      },
      {
        path: "organizationCharge/report",
        name: "organizationCharge.report",
        component: ReportOrgenizationCharge,
        meta: { title: "گزارشات شارژ کارت" },
      },
      {
        path: "direct-debit",
        name: "organization.directDebit",
        component: OrganizationDirectDebit,
        meta: { title: "شارژ مستقیم سازمان" },
      },
      {
        path: "change-pin",
        name: "changePin",
        component: ChangeCardPin,
        meta: { title: "تغییر رمز مستقیم" },
      },
      {
        path: "reports/change-pin",
        name: "changePin.reports",
        component: ChangeCardPinReport,
        meta: { title: "گزارشات تغییر رمز مستقیم" },
      },
    ],
  },
];
